var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAnalyticscalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.015 1.243h-2.07V.788c0-.438-.336-.788-.757-.788-.42 0-.757.35-.757.788v.455H5.535V.788C5.535.35 5.2 0 4.778 0c-.42 0-.757.35-.757.788v.455H1.968C.892 1.243 0 2.153 0 3.29v10.66C0 15.073.875 16 1.968 16h12.064C15.108 16 16 15.09 16 13.952V3.29c-.017-1.138-.892-2.048-1.985-2.048zM1.968 2.818h2.07v.456c0 .437.336.787.757.787.42 0 .757-.35.757-.787v-.456h4.896v.456c0 .437.336.787.757.787.42 0 .757-.35.757-.787v-.456h2.07c.252 0 .454.21.454.473v2.083H1.514V3.291c0-.263.202-.473.454-.473zm12.047 11.607H1.968a.462.462 0 01-.454-.473v-7.02h12.972v7.02c-.017.262-.219.473-.471.473z",
    fill: "#6E7680",
    fillRule: "nonzero"
  })));
}

export default SvgAnalyticscalendar;